import { RegistrationEventListItem } from '@event/types';
import { createContext, useContext } from 'react';

const AttendedEventsContext = createContext<
    | {
          downloadingCertificateKey: Record<string, boolean>;
          handleDownloadCertificate: (event: RegistrationEventListItem) => Promise<void>;
      }
    | undefined
>(undefined);

const useAttendedEventsContext = () => {
    const context = useContext(AttendedEventsContext);
    if (!context) throw new Error('useAttendedEventsContext must be used within a provider');
    return context;
};

export { AttendedEventsContext, useAttendedEventsContext };
